export enum AvailabilityStatus {
	Available = "available",
	NotAvailable = "not_available"
};
